import { useEffect, useState } from "react"
import { ANGULAR_IR_HEATMAP_SIZES, ANGULAR_METAL_HEATMAP_SIZES, ANGULAR_THZ_HEATMAP_SIZES, PATCH_IR_HEATMAP_SIZES, PATCH_METAL_HEATMAP_SIZES, PATCH_THZ_HEATMAP_SIZES } from "../../../../utils/constants"
import { UseAnalysisControlsProps } from "./AnalysisControls.types"

const useAnalysisControls = (props: UseAnalysisControlsProps) => {

  const { vertical } = props

  const [selectedDisplayOption, setSelectedDisplayOption] = useState<number>(0)
  const [showOverlay, setShowOverlay] = useState<boolean>(false)
  const [showHighlightMin, setShowHighlightMin] = useState<boolean>(false)
  const [showHighlightMax, setShowHighlightMax] = useState<boolean>(false)
  const [selectedScanHeightIndex, setSelectedScanHeightIndex] = useState<number>(0)
  const [selectedTHzScanHeight, setSelectedTHzScanHeight] = useState<number>(0)
  const [selectedIRScanHeight, setSelectedIRScanHeight] = useState<number>(0)
  const [selectedMetalScanHeight, setSelectedMetalScanHeight] = useState<number>(0)
  const scanHeights = PATCH_THZ_HEATMAP_SIZES.map((_, i) => `${i+1}`)

  useEffect(() => {
    setSelectedScanHeightIndex(vertical ? 1 : 2)    
  }, [vertical])

  useEffect(() => {    
    if (vertical) {
      setSelectedTHzScanHeight(PATCH_THZ_HEATMAP_SIZES[selectedScanHeightIndex])
      setSelectedIRScanHeight(PATCH_IR_HEATMAP_SIZES[selectedScanHeightIndex])
      setSelectedMetalScanHeight(PATCH_METAL_HEATMAP_SIZES[selectedScanHeightIndex])
    } else {
      setSelectedTHzScanHeight(ANGULAR_THZ_HEATMAP_SIZES[selectedScanHeightIndex])
      setSelectedIRScanHeight(ANGULAR_IR_HEATMAP_SIZES[selectedScanHeightIndex])
      setSelectedMetalScanHeight(ANGULAR_METAL_HEATMAP_SIZES[selectedScanHeightIndex])
    }
  }, [selectedScanHeightIndex, vertical])

  return [{
    selectedDisplayOption: {value: selectedDisplayOption, onChange: setSelectedDisplayOption},
    overlayAnalysisCheckbox: {value: showOverlay, onChange: () => setShowOverlay(!showOverlay)},
    minHighlightCheckbox: {value: showHighlightMin, onChange: () => setShowHighlightMin(!showHighlightMin)},
    maxHighlightCheckbox: {value: showHighlightMax, onChange: () => setShowHighlightMax(!showHighlightMax)},
    scanHeightDropdown: {values: scanHeights, selected: selectedScanHeightIndex, onChange: setSelectedScanHeightIndex},
    selectedTHzScanHeight,
    selectedIRScanHeight,
    selectedMetalScanHeight
  }]
}

export default useAnalysisControls